/**
 * Ticket 3021 (Weg 2): Spiegel-Blatt nach einem Neuladen wieder öffnen.
 *
 * Ruft Martin „Essenzspiegel vorlesen“, erscheint der Player erst, wenn
 * Vesperas Satz verklungen ist (Ticket 2698: keine Karte, der Player ist die
 * Antwort). Wird die Seite davor neu geladen, ist der Zuruf verloren und der
 * Abspielknopf weg. Darum merkt sich das Gerät den Zuruf kurz: Tag + Zeit.
 *
 * Der Merker wird EINMAL gebraucht: der Start liest und löscht ihn, das
 * Schließen des Blatts löscht ihn auch. Kein Autoplay — das Blatt öffnet nur.
 * Die Fehler von localStorage (gesperrt, voll) sind still: dann gibt es
 * keinen Merker, und alles bleibt wie vorher.
 */
export const SPIEGEL_OFFEN_SCHLUESSEL = "voice-v8.spiegel-offen";
export const SPIEGEL_OFFEN_MAX_MS = 30 * 60_000;

/** Der Kalendertag in Wiener Zeit (YYYY-MM-DD). */
export function wienerTag(jetzt: number): string {
  return new Date(jetzt).toLocaleDateString("en-CA", { timeZone: "Europe/Vienna" });
}

/** Beim Zuruf `abspielen` (Spiegel): merken. */
export function merkeSpiegelOffen(jetzt: number = Date.now()): void {
  try {
    localStorage.setItem(
      SPIEGEL_OFFEN_SCHLUESSEL,
      JSON.stringify({ tag: wienerTag(jetzt), ts: jetzt }),
    );
  } catch {
    /* localStorage gesperrt */
  }
}

/** Beim Schließen / nach Gebrauch: vergessen. */
export function vergissSpiegelOffen(): void {
  try {
    localStorage.removeItem(SPIEGEL_OFFEN_SCHLUESSEL);
  } catch {
    /* localStorage gesperrt */
  }
}

/**
 * Beim Start: gibt es einen frischen Merker? Liest UND löscht ihn — ein
 * zweites Neuladen öffnet nichts mehr.
 */
export function nimmSpiegelOffen(jetzt: number = Date.now()): boolean {
  let roh: string | null = null;
  try {
    roh = localStorage.getItem(SPIEGEL_OFFEN_SCHLUESSEL);
  } catch {
    return false;
  }
  if (roh === null) return false;
  vergissSpiegelOffen();
  try {
    const m = JSON.parse(roh) as { tag?: unknown; ts?: unknown };
    if (typeof m.tag !== "string" || typeof m.ts !== "number") return false;
    const alter = jetzt - m.ts;
    return alter >= 0 && alter < SPIEGEL_OFFEN_MAX_MS && m.tag === wienerTag(jetzt);
  } catch {
    return false;
  }
}
